import "core-js/modules/es6.regexp.split.js";
import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es6.number.is-nan.js";
import { SemverValidationError } from '../errors'; // this module throws SemverValidationError, so re-export it from here

export { SemverValidationError };
export function validateSemver(semver) {
  if (typeof semver !== 'string') throw new SemverValidationError("`".concat(semver, "`: semver must be a string"));
  var parts = semver.split('.');
  if (parts.length !== 3) throw new SemverValidationError("`".concat(semver, "`: semver must contain three parts"));

  for (var i = 0; i < 3; i += 1) {
    var num = Number(parts[i]);
    if (Number.isNaN(num)) throw new SemverValidationError("`".concat(semver, "`: semver parts must be number char(s)"));
  }
} // modeled after: https://github.com/substack/semver-compare/blob/master/index.js

export default function compareSemvers(a, b) {
  if (typeof a !== 'string') throw new SemverValidationError("`".concat(a, "`: semver must be a string"));
  if (typeof b !== 'string') throw new SemverValidationError("`".concat(b, "`: semver must be a string"));
  var pa = a.split('.');
  if (pa.length !== 3) throw new SemverValidationError("`".concat(a, "`: semver must contain three parts"));
  var pb = b.split('.');
  if (pb.length !== 3) throw new SemverValidationError("`".concat(b, "`: semver must contain three parts"));

  for (var i = 0; i < 3; i += 1) {
    var na = Number(pa[i]);
    if (Number.isNaN(na)) throw new SemverValidationError("`".concat(a, "`: semver parts must be number char(s)"));
    var nb = Number(pb[i]);
    if (Number.isNaN(nb)) throw new SemverValidationError("`".concat(b, "`: semver parts must be number char(s)"));
    if (na > nb) return 1;
    if (nb > na) return -1;
  }

  return 0;
}